module.exports = __webpack_public_path__ + "static/media/ni-4.447a68aa.jpg";